import type { Suggestion } from '@rp/contracts'
import { useState } from 'react'

type Selection = { suggestionId: string; ids: readonly string[] }

export const useGroundingSelection = (suggestion: Suggestion | null) => {
  const [selection, setSelection] = useState<Selection | null>(null)
  const groundingIds = suggestion?.grounding.map((source) => source.id) ?? []
  const fresh = suggestion !== null && selection?.suggestionId === suggestion.id
  const selectedIds = fresh && selection !== null ? selection.ids : groundingIds

  const toggle = (id: string) => {
    if (suggestion === null) return
    setSelection({
      suggestionId: suggestion.id,
      ids: selectedIds.includes(id) ? selectedIds.filter((each) => each !== id) : [...selectedIds, id],
    })
  }

  return { selectedIds, toggle }
}
